export const userData = [
  {
    name: "Jan",
    "Active User": 4000,
  },
  {
    name: "Feb",
    "Active User": 3000,
  },
  {
    name: "Mar",
    "Active User": 5000,
  },
  {
    name: "Apr",
    "Active User": 4000,
  },
  {
    name: "May",
    "Active User": 3000,
  },
  {
    name: "Jun",
    "Active User": 2000,
  },
  {
    name: "Jul",
    "Active User": 4000,
  },
  {
    name: "Agu",
    "Active User": 3000,
  },
  {
    name: "Sep",
    "Active User": 4000,
  },
  {
    name: "Oct",
    "Active User": 1000,
  },
  {
    name: "Nov",
    "Active User": 4000,
  },
  {
    name: "Dec",
    "Active User": 3000,
  },
];

export const productData = [
  {
    name: "Jan",
    Sales: 4000,
  },
  {
    name: "Feb",
    Sales: 3000,
  },
  {
    name: "Mar",
    Sales: 5000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 2,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 3,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 4,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 5,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 6,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 7,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 8,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 9,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 10,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
];

export const productRows = [
  {
    id: 1,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 2,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 3,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 4,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 5,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 6,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 7,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 8,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 9,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 10,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
];
export const influencerList = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 8,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 9,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 10,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 11,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
  {
    id: 12,
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    kullanıcıAdı: 123,
    instaLink: "https://www.instagram.com/hknerya/",
    onayNotu: "Onay notu Onay notu Onay notu Onay notu Onay notu",
  },
];
export const advertList = [
  {
    id: 1,
    marka_name: "Pınar",
    product_name: "Burger",
    conditions_of_participation: "Open account",
    project_details: "Project Details",
    adress: "Adress",
    supertext: "supertext",
    subtext: "subtext",
    nots: "nots",
    content_type: "content_type",
    min_price: 0,
    max_price: 500,
    gender: "E",
    product_shipping: 1,
  },
  {
    id: 2,
    marka_name: "Pınar",
    product_name: "Burger",
    conditions_of_participation: "Open account",
    project_details: "Project Details",
    adress: "Adress",
    supertext: "supertext",
    subtext: "subtext",
    nots: "nots",
    content_type: "content_type",
    min_price: 0,
    max_price: 500,
    gender: "E",
    product_shipping: 1,
  },
  {
    id: 3,
    marka_name: "Pınar",
    product_name: "Burger",
    conditions_of_participation: "Open account",
    project_details: "Project Details",
    adress: "Adress",
    supertext: "supertext",
    subtext: "subtext",
    nots: "nots",
    content_type: "content_type",
    min_price: 0,
    max_price: 500,
    gender: "E",
    product_shipping: 1,
  },
  {
    id: 4,
    marka_name: "Pınar",
    product_name: "Burger",
    conditions_of_participation: "Open account",
    project_details: "Project Details",
    adress: "Adress",
    supertext: "supertext",
    subtext: "subtext",
    nots: "nots",
    content_type: "content_type",
    min_price: 0,
    max_price: 500,
    gender: "E",
    product_shipping: 1,
  },
  {
    id: 5,
    marka_name: "Pınar",
    product_name: "Burger",
    conditions_of_participation: "Open account",
    project_details: "Project Details",
    adress: "Adress",
    supertext: "supertext",
    subtext: "subtext",
    nots: "nots",
    content_type: "content_type",
    min_price: 0,
    max_price: 500,
    gender: "E",
    product_shipping: 1,
  },
];
